<template>
  <div class="main_box">
    <h2 class="hidden-md-and-up">个人资料</h2>
    <div class="body_card">
      <div class="form_bar">基本信息</div>
      <div class="form_content">
        <el-row>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 18 }"
            :lg="{ span: 18 }"
            :xl="{ span: 18 }"
          >
            <div class="personal_info_detail">
              <div class="personal_name_container">
                <div class="personal_head_img">
                  <el-avatar :size="photoSize" :src="userDetail.UserPhoto">
                    <img :src="defaultPhoto" />
                  </el-avatar>
                </div>
                <div class="personal_name_text">
                  {{ userDetail.UserName }}
                  <el-link
                    title="编辑个人信息"
                    type="primary"
                    @click="openEditPersonal()"
                  >
                    <i class="el-icon-edit"></i>
                  </el-link>
                </div>
              </div>
              <div class="personal_info_part" v-if="isCompanySystem">
                <p class="personal_info_part_title">单位名称：</p>
                <span class="personal_info_part_text">
                  {{ userDetail.CompanyName }}
                </span>
              </div>
              <div class="personal_info_part" v-if="false">
                <p class="personal_info_part_title">企业编码：</p>
                <span class="personal_info_part_text">
                  {{ userDetail.OrgCode }}
                </span>
              </div>
              <div class="personal_info_part">
                <p class="personal_info_part_title">角色：</p>
                <span class="personal_info_part_text">
                  {{ userDetail.RoleName }}
                </span>
              </div>
              <div class="personal_info_part">
                <p class="personal_info_part_title">手机号：</p>
                <span class="personal_info_part_text">
                  {{ userDetail.Phone }}
                </span>
              </div>
              <div class="personal_info_part">
                <p class="personal_info_part_title">绑定微信：</p>
                <span
                  class="personal_info_part_text"
                  v-if="userDetail.IsBindWechat"
                >
                  {{ userDetail.WNickName }}
                </span>
                <el-link
                  type="primary"
                  class="personal_info_part_operate"
                  v-if="!userDetail.IsBindWechat"
                  @click="showBindWeChat = true"
                >
                  未绑定
                </el-link>
                <el-link
                  type="info"
                  class="personal_info_part_operate"
                  v-if="userDetail.IsBindWechat"
                  :disabled="true"
                  >已绑定</el-link
                >
              </div>
              <div class="personal_info_part" v-if="showBindWeChat">
                <div class="personal_info_part_code">
                  <span>请使用微信扫描二维码</span>
                  <wxlogin
                    :theme="'black'"
                    :appid="this.$config.wxAppId"
                    :scope="this.$config.wxSnsapiLogin"
                    :redirect_uri="this.$config.wxBindRedirectUri"
                    :href="wxCustomStyle"
                    style="
                      width: 200px;
                      height: 200px;
                      overflow: hidden;
                      margin-left: -10px;
                    "
                  ></wxlogin>
                  <el-button size="mini" @click="showBindWeChat = false">
                    取消
                  </el-button>
                </div>
              </div>
              <div class="personal_info_part">
                <el-link
                  type="primary"
                  :underline="false"
                  v-if="!showCancelAccount"
                  @click="showCancelAccount = true"
                >
                  更多
                </el-link>
                <el-link
                  type="primary"
                  :underline="false"
                  v-if="showCancelAccount"
                  @click="openCancelAccount()"
                >
                  账号注销
                  <i class="iconfont icon-bangzhu"></i>
                </el-link>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 6 }"
            :lg="{ span: 6 }"
            :xl="{ span: 6 }"
          >
            <div class="personal_account_info">
              <span>
                <i class="iconfont icon-huiyuan2"></i>
                {{ userDetail.UserMoneyBalanceInfo }}
              </span>
              <el-button
                type="primary"
                size="small"
                @click="recharge()"
                v-if="isCompanySystem"
              >
                充值
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="body_card">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="购买纪录" name="moneyOrders" v-if="isCompanySystem">
        </el-tab-pane>
        <el-tab-pane label="使用纪录" name="moneyUsering"> </el-tab-pane>
        <el-tab-pane label="用户管理" name="userManage" v-if="isCompanySystem">
        </el-tab-pane>
        <el-tab-pane label="充值" name="recharge" v-if="isCompanySystem">
        </el-tab-pane>
      </el-tabs>
      <router-view :isCompanySystem="isCompanySystem" />
    </div>
    <el-dialog
      title="编辑个人信息"
      :visible.sync="editUserInfoDialogVisible"
      :close-on-click-modal="false"
      @close="dialogClose"
      custom-class="custom_dialog"
    >
      <el-row>
        <el-col :span="22" :offset="1">
          <el-form
            :model="personalInfoForm"
            :rules="personalInfoFormRules"
            ref="personalInfoForm"
            label-width="120px"
            class="demo-ruleForm"
            size="mini"
            :label-position="is_xs ? 'top' : 'left'"
          >
            <el-form-item label="姓名：" prop="UserName">
              <el-input
                v-model="personalInfoForm.UserName"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="单位名称："
              prop="CompanyName"
              v-if="isCompanySystem"
            >
              <el-input
                v-model="personalInfoForm.CompanyName"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="修改头像：">
              <el-upload
                class="avatar-uploader"
                ref="photoUpload"
                :file-list="photoFileList"
                action="#"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :limit="1"
                :http-request="photoHandleUpload"
                :auto-upload="false"
                :show-file-list="true"
                list-type="picture-card"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="修改公司Logo：" v-show="isCompanySystem">
              <el-upload
                class="avatar-uploader"
                ref="companyUpload"
                :file-list="companyFileList"
                action="#"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :limit="1"
                :http-request="companyHandleUpload"
                :auto-upload="false"
                :show-file-list="true"
                list-type="picture-card"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editUserInfoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editPersonalInfo()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import wxlogin from 'vue-wxlogin'
export default {
  name: 'personal',
  components: {
    wxlogin
  },
  data () {
    return {
      photoSize: 60,
      userDetail: {},
      defaultPhoto: require('../../../assets/images/photo.png'),
      activeName: 'moneyOrders',
      editUserInfoDialogVisible: false,
      personalInfoForm: {
        UserId: null,
        UserName: null,
        CompanyId: null,
        CompanyName: null
      },
      personalInfoFormRules: {
        UserName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 100, message: '姓名过长！', trigger: 'blur' }],
        CompanyName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' },
          { min: 1, max: 100, message: '单位名称过长！', trigger: 'blur' }]
      },
      photoFileList: [],
      companyFileList: [],
      showBindWeChat: false,
      wxCustomStyle: 'data:text/css;base64,LmltcG93ZXJCb3ggewogIHRleHQtYWxpZ246IGxlZnQ7Cn0KLmltcG93ZXJCb3ggLnRpdGxlIHsKICBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgewogIGRpc3BsYXk6IG5vbmU7Cn0KLmltcG93ZXJCb3ggLnFyY29kZSB7CiAgbWFyZ2luLXRvcDogMHB4OwogIGJvcmRlcjogbm9uZTsKICB3aWR0aDogMjAwcHg7CiAgaGVpZ2h0OiAyMDBweDsKfQouaW1wb3dlckJveCAuc3RhdHVzIHsKICBkaXNwbGF5OiBub25lOwp9',
      showCancelAccount: false,
      isCompanySystem: false
    }
  },
  methods: {
    getManagerUserDetail: function () {
      const _this = this
      _this.openLoading()
      _this.$api.userInfo.getManagerUserDetail().then(data => {
        _this.userDetail = data
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    handleClick (tab, event) {
      switch (tab.name) {
        case 'moneyOrders':
          this.$router.push({ path: '/personal/moneyOrders' })
          break
        case 'moneyUsering':
          this.$router.push({ path: '/personal/moneyUsering' })
          break
        case 'userManage':
          this.$router.push({ path: '/personal/userManage' })
          break
        case 'recharge':
          this.$router.push({ path: '/personal/recharge' })
          break
      }
    },
    openEditPersonal: function () {
      const _this = this
      _this.personalInfoForm.UserId = _this.userDetail.UserId
      _this.personalInfoForm.UserName = _this.userDetail.UserName
      _this.personalInfoForm.CompanyId = _this.userDetail.CompanyId
      _this.personalInfoForm.CompanyName = _this.userDetail.CompanyName
      if (_this.userDetail.UserPhoto) {
        const obj = {}
        obj.url = _this.userDetail.UserPhoto
        _this.photoFileList.push(obj)
      }
      if (_this.userDetail.CompanyLogo) {
        const obj = {}
        obj.url = _this.userDetail.CompanyLogo
        _this.companyFileList.push(obj)
      }
      _this.editUserInfoDialogVisible = true
    },
    dialogClose: function (done) {
      const _this = this
      _this.photoFileList = []
      _this.companyFileList = []
    },
    editPersonalInfo: function () {
      const _this = this
      _this.openLoading()
      _this.$refs.personalInfoForm.validate((valid) => {
        if (valid) {
          this.$refs.photoUpload.submit()
          this.$refs.companyUpload.submit()
          const fd = new FormData()
          fd.append('UserId', _this.personalInfoForm.UserId)
          fd.append('UserName', _this.personalInfoForm.UserName)
          fd.append('CompanyId', _this.personalInfoForm.CompanyId)
          fd.append('CompanyName', _this.personalInfoForm.CompanyName)
          this.photoFileList.forEach(function (file) {
            fd.append('userFile', file)
          })
          this.companyFileList.forEach(function (file) {
            fd.append('companyFile', file)
          })
          _this.$api.userInfo.editPersonalInfo(fd).then(data => {
            _this.$message({
              showClose: true,
              type: 'success',
              message: '修改成功！',
              customClass: 'custom_message'
            })
            _this.editUserInfoDialogVisible = false
            _this.getManagerUserDetail()
          }).catch(err => {
            _this.openLoading().close()
            _this.editUserInfoDialogVisible = false
            return err
          })
        } else {
          _this.openLoading().close()
          return false
        }
      })
    },
    photoHandleUpload: function (raw) {
      const _this = this
      _this.photoFileList.push(raw.file)
    },
    companyHandleUpload: function (raw) {
      const _this = this
      _this.companyFileList.push(raw.file)
    },
    recharge: function () {
      //   this.$router.push({ path: '/financial' })
      this.$router.push({ path: '/personal/recharge' })
      this.activeName = 'recharge'
    },
    bindWeChat () {
      const _this = this
      if (_this.$route.query.code) {
        _this.openLoading()
        _this.$api.account.bindWeChat({ Code: _this.$route.query.code }).then(data => {
          // _this.getManagerUserDetail()
          _this.$message({
            showClose: true,
            type: 'success',
            message: '微信绑定成功！',
            customClass: 'custom_message'
          })
          _this.openLoading().close()
          _this.getManagerUserDetail()
          _this.$router.push({ path: '/personal' })
          _this.showBindWeChat = false
        }).catch(err => {
          _this.getManagerUserDetail()
          _this.$router.push({ path: '/personal' })
          _this.showBindWeChat = false
          return err
        })
      }
    },
    openCancelAccount: function () {
      this.$router.push({ path: '/cancelAccount' })
    },
    getIsCompanySystem () {
      const _this = this
      _this.$api.role.getIsCompanySystem().then(data => {
        _this.isCompanySystem = data.IsCompanyAdmin
        switch (_this.$route.name) {
          case 'personal':
            if (_this.isCompanySystem) {
              _this.$router.push({ path: '/personal/moneyOrders' })
              _this.activeName = 'moneyOrders'
            } else {
              _this.$router.push({ path: '/personal/moneyUsering' })
              _this.activeName = 'moneyUsering'
            }
            break
          case 'moneyOrders':
            if (_this.isCompanySystem) {
              _this.$router.push({ path: '/personal/moneyOrders' })
              _this.activeName = 'moneyOrders'
            } else {
              _this.$router.push({ path: '/personal/moneyUsering' })
              _this.activeName = 'moneyUsering'
            }
            break
          case 'moneyUsering':
            _this.activeName = 'moneyUsering'
            break
          case 'userManage':
            if (_this.isCompanySystem) {
              _this.$router.push({ path: '/personal/userManage' })
              _this.activeName = 'userManage'
            } else {
              _this.$router.push({ path: '/personal/moneyUsering' })
              _this.activeName = 'moneyUsering'
            }
            break
          case 'recharge':
            if (_this.isCompanySystem) {
              _this.$router.push({ path: '/personal/recharge' })
              _this.activeName = 'recharge'
            } else {
              _this.$router.push({ path: '/personal/moneyUsering' })
              _this.activeName = 'moneyUsering'
            }
            break
        }
      }).catch(err => {
        return err
      })
    }
  },
  watch: {
    '$route' (to, from) {
      const _this = this
      if (_this.$route.query.code) {
        _this.bindWeChat()
      }
    }
  },
  created () {
    const _this = this
    if (_this.$route.query.code) {
      _this.bindWeChat()
    } else {
      _this.getManagerUserDetail()
    }
    _this.getIsCompanySystem()
  }
}
</script>
<style lang="less">
// 自定义二维码样式(以下样式需要生成为base64，href必须使用 text/css模式,生成的base64添加到"data:text/css;base64")
.impowerBox {
  text-align: left;
}
.impowerBox .title {
  display: none;
}
.impowerBox .status.status_browser {
  display: none;
}
.impowerBox .qrcode {
  margin-top: 0px;
  border: none;
  width: 200px;
  height: 200px;
}
.impowerBox .status {
  display: none;
}
</style>
